// @mui material components
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";

// formik components
import { useFormikContext } from "formik";
import { useFormAnalyticsContext } from "contexts/contextFormAnalytics";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

import FormField from "components/FormField";

function InsulinForm({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { lifeExpectancy, startYearInsulin } = formField;

  const { countryDefaults } = useFormAnalyticsContext();
  const { setFieldValue } = useFormikContext<any>();

  const resetValues = () => {
    setFieldValue(formField.startYearInsulin.name, countryDefaults.startYearInsulin);
  };

  return (
    <MDBox>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <MDTypography variant="h6" sx={{ whiteSpace: "pre-wrap" }}>
            Life expectancy without insulin (years):
          </MDTypography>
          <FormField
            disabled={true}
            type={lifeExpectancy.type}
            label={lifeExpectancy.label}
            name={lifeExpectancy.name}
            value={values.lifeExpectancy}
            placeholder={lifeExpectancy.placeholder}
            error={errors.lifeExpectancy && touched.lifeExpectancy}
            precision={2}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MDTypography variant="h6" sx={{ whiteSpace: "pre-wrap" }}>
            Year of insulin introduction:{"\n"}
            <MDButton
              variant="gradient"
              color="dark"
              size="small"
              iconOnly
              onClick={() => resetValues()}
            >
              <RefreshIcon />
            </MDButton>
          </MDTypography>
          <FormField
            type={startYearInsulin.type}
            label={startYearInsulin.label}
            name={startYearInsulin.name}
            value={values.startYearInsulin}
            formatted={false}
            placeholder={startYearInsulin.placeholder}
            error={errors.startYearInsulin}
          />
        </Grid>
        <Grid item xs={12}>
          <MDTypography
            variant="caption"
            color="error"
            fontWeight="regular"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {errors.startYearInsulin || errors.lifeExpectancy}
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default InsulinForm;
